var map = {
	"./bulb.svg": 116,
	"./check.svg": 1516,
	"./chf-flag.svg": 312,
	"./country/aud-flag.svg": 684,
	"./country/cad-flag.svg": 685,
	"./country/cny-flag.svg": 686,
	"./country/hkd-flag.svg": 687,
	"./country/inr-flag.svg": 688,
	"./country/jpy-flag.svg": 689,
	"./country/pln-flag.svg": 690,
	"./ddl-search.svg": 313,
	"./delete-icon.svg": 307,
	"./disable-process-three.svg": 1517,
	"./disable-process-two.svg": 1518,
	"./done-chk-white.svg": 115,
	"./drag.svg": 308,
	"./eur-flag.svg": 309,
	"./first-open-process.svg": 1519,
	"./gbp-flag.svg": 311,
	"./usd-flag.svg": 310
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 683;